import { faCheck, faDiagramProject, faEye, faFilter, faFlagCheckered, faPen, faRocket, faTag, faUser, faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ModalUpdate from "./ModalUpdate";
import { loadList, loadLabelList, loadUserList, loadCheckList, filterLabel, filterProject, filterUser } from '../../../reducers/models/task/taskList';
import DisplayTable from "./DisplayTable";

//РЕДЮСЕРЫ ФИЛЬТРОВ
import FilterDate from "../../../components/filter/FilterDate";
import TabBar from "../../../components/ui/TabBar";
import InfoNoData from "../../../components/global/InfoNoData";
import axios from "axios";
import FilterUniversal from "../../../components/filter/FilterUniversal";
import TaskModalAdd from "../../../components/modal/TaskModalAdd";
import ErrorAdd from "../../../util/ErrorAdd";

function Index() {

    const id_object = 1;
    const stateList = useSelector((state) => state.taskList);//Редюсер задач
    const stateSetting = useSelector((state) => state.setting);//Настройки приложения
    const stateUserList = useSelector((state) => state.userList);//Пользователи    

    //TAB START
    const [tab, setTab] = useState([
        { id_tab: 0, name: "Черновики", icon: faPen, showCount: false, hideUser: false, loading: false, loading1: false, loading2: false, loading3: false }
        , { id_tab: 1, name: "Исполнитель", icon: faCheck, showCount: true, hideUser: false, loading: false, loading1: false, loading2: false, loading3: false }
        , { id_tab: 2, name: "Наблюдатель", icon: faEye, showCount: true, hideUser: false, loading: false, loading1: false, loading2: false, loading3: false }
        , { id_tab: 3, name: "Будущие", icon: faRocket, showCount: false, hideUser: false, loading: false, loading1: false, loading2: false, loading3: false }
        , { id_tab: 4, name: "Все задачи", icon: faUsers, showCount: false, hideUser: true, loading: false, loading1: false, loading2: false, loading3: false }
        , { id_tab: 5, name: "Выполненные", icon: faFlagCheckered, showCount: false, hideUser: false, loading: false, loading1: false, loading2: false, loading3: false }
    ]);

    const [filterShow, setFilterShow] = useState(false);
    const [tabSelected, setTabSelected] = useState(1);
    const [log, setLog] = useState(false);
    //TAB END

    const dispatch = useDispatch()

    const [filterLabelList, setFilterLabelList] = useState([]);//Данные для фильтра с метками.
    const [filterUserList, setFilterUserList] = useState([]);//Данные для фильтра с пользователями.

    useEffect(() => {
        if (tab.filter(a => a.id_tab === tabSelected & a.loading1 === false & a.loading2 === false & a.loading3 === false & a.loading === true).length > 0) {
            setTab(tab_ => tab_.map(item => {
                if (item.id_tab === tabSelected) {
                    return { ...item, loading: false }
                }
                else {
                    return item;
                }
            }))
        }
    }, [tab, tabSelected]);

    //Подгрузка данных необходимых для задач
    function loadDataForTask(id_tasks, id_tab) {

        //Подгружаем метки
        axios.get('/api_tracker/task/widgetLabelListByTasks', { params: { ID_Tasks: id_tasks.join(',') } })
            .then((res) => {
                if (res.data.Status === 1) {
                    dispatch(loadLabelList({ list: res.data.Data, id_tab: id_tab }));
                }
                else {
                    setLog(res.data.Error);
                }

                setTab(tab_ => tab_.map(item => {
                    if (item.id_tab === id_tab) {
                        return { ...item, loading1: false }
                    }
                    else {
                        return item;
                    }
                }))
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setTab(tab_ => tab_.map(item => {
                    if (item.id_tab === id_tab) {
                        return { ...item, loading1: false }
                    }
                    else {
                        return item;
                    }
                }))
                ErrorAdd(err, window.location.href);
            });

        //Подгружаем чек-боксы
        axios.get('/api_tracker/task/widgetCheckListByTasks', { params: { ID_Tasks: id_tasks.join(',') } })
            .then((res) => {
                if (res.data.Status === 1) {
                    dispatch(loadCheckList({ list: res.data.Data, id_tab: id_tab }));
                }
                else {
                    setLog(res.data.Error);
                }
                setTab(tab_ => tab_.map(item => {
                    if (item.id_tab === id_tab) {
                        return { ...item, loading2: false }
                    }
                    else {
                        return item;
                    }
                }))
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setTab(tab_ => tab_.map(item => {
                    if (item.id_tab === id_tab) {
                        return { ...item, loading2: false }
                    }
                    else {
                        return item;
                    }
                }))
                ErrorAdd(err, window.location.href);
            });
        //Подгружаем пользователей
        axios.get('/api_tracker/task/userListByTasks', { params: { ID_Tasks: id_tasks.join(',') } })
            .then((res) => {
                if (res.data.Status === 1) {
                    dispatch(loadUserList({ list: res.data.Data, id_tab: id_tab }));
                }
                else {
                    setLog(res.data.Error);
                }
                setTab(tab_ => tab_.map(item => {
                    if (item.id_tab === id_tab) {
                        return { ...item, loading3: false }
                    }
                    else {
                        return item;
                    }
                }))
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setTab(tab_ => tab_.map(item => {
                    if (item.id_tab === id_tab) {
                        return { ...item, loading3: false }
                    }
                    else {
                        return item;
                    }
                }))
                ErrorAdd(err, window.location.href);
            });
    }

    useEffect(() => {

        //СПИСКИ ЗАДАЧ
        //Загружаем черновики
        if (stateList.listLoaded.filter(a => a.id_tab === 0).length === 0) {

            setTab(tab_ => tab_.map(item => {
                if (item.id_tab === 0) {
                    return { ...item, loading: true, loading1: true, loading2: true, loading3: true }
                }
                else {
                    return item;
                }
            }))

            axios.get('/api_tracker/task/listDraft')
                .then((res) => {
                    if (res.data.Status === 1) {
                        dispatch(loadList({ list: res.data.Data, id_tab: 0 }));
                        //Заполняем ИД задач                   
                        const id_tasks = res.data.Data.map((item) => {
                            return item.ID;
                        })

                        if (id_tasks.length > 0) {
                            loadDataForTask(id_tasks, 0)
                        }
                        else {
                            setTab(tab_ => tab_.map(item => {
                                if (item.id_tab === 0) {
                                    return { ...item, loading: false, loading1: false, loading2: false, loading3: false }
                                }
                                else {
                                    return item;
                                }
                            }))
                        }
                    }
                })
                .catch((err) => {
                    ErrorAdd(err, window.location.href);
                });

        }
        //Загружаем активные задачи "Исполнитель"
        if (stateList.listLoaded.filter(a => a.id_tab === 1).length === 0) {

            setTab(tab_ => tab_.map(item => {
                if (item.id_tab === 1) {
                    return { ...item, loading: true, loading1: true, loading2: true, loading3: true }
                }
                else {
                    return item;
                }
            }))

            axios.get('/api_tracker/task/listActive', { params: { ID_Action: 2 } })
                .then((res) => {
                    if (res.data.Status === 1) {
                        dispatch(loadList({ list: res.data.Data, id_tab: 1 }));
                        //Заполняем ИД задач                   
                        const id_tasks = res.data.Data.map((item) => {
                            return item.ID;
                        })

                        if (id_tasks.length > 0) {
                            loadDataForTask(id_tasks, 1)
                        }
                        else {
                            setTab(tab_ => tab_.map(item => {
                                if (item.id_tab === 1) {
                                    return { ...item, loading: false, loading1: false, loading2: false, loading3: false }
                                }
                                else {
                                    return item;
                                }
                            }))
                        }
                    }
                })
                .catch((err) => {
                    ErrorAdd(err, window.location.href);
                });
        }
        //Загружаем активные задачи "Наблюдатель"
        if (stateList.listLoaded.filter(a => a.id_tab === 2).length === 0) {

            setTab(tab_ => tab_.map(item => {
                if (item.id_tab === 2) {
                    return { ...item, loading: true, loading1: true, loading2: true, loading3: true }
                }
                else {
                    return item;
                }
            }))

            axios.get('/api_tracker/task/listActive', { params: { ID_Action: 1 } })
                .then((res) => {
                    if (res.data.Status === 1) {
                        dispatch(loadList({ list: res.data.Data, id_tab: 2 }));
                        //Заполняем ИД задач                   
                        const id_tasks = res.data.Data.map((item) => {
                            return item.ID;
                        })

                        if (id_tasks.length > 0) {
                            loadDataForTask(id_tasks, 2)
                        }
                        else {
                            setTab(tab_ => tab_.map(item => {
                                if (item.id_tab === 2) {
                                    return { ...item, loading: false, loading1: false, loading2: false, loading3: false }
                                }
                                else {
                                    return item;
                                }
                            }))
                        }
                    }
                })
                .catch((err) => {
                    ErrorAdd(err, window.location.href);
                });
        }
    }, []);

    useEffect(() => {
        //Обновляем счетчик задач
        setTab(tab_ => tab_.map(t => {
            if (t.id_tab === 0) {
                return { ...t, count: stateList.list.filter(a => a.id_tab === 0).length }
            }
            else if (t.id_tab === 1) {
                return { ...t, count: stateList.list.filter(a => a.id_tab === 1).length }
            }
            else if (t.id_tab === 2) {
                return { ...t, count: stateList.list.filter(a => a.id_tab === 2).length }
            }
            else {
                return t;
            }
        }))

    }, [stateList.list]);

    useEffect(() => {

        var filter_list = [];

        //Преобразовываем метки в нужный формат
        stateList.listLabel.map((item) => {
            if (filter_list.filter(a => a.id === item.ID_Label & a.id_tab === item.id_tab).length == 0) {
                filter_list.push({ id: item.ID_Label, id_tab: item.id_tab, name: item.Name, color: item.Color, count: stateList.listLabel.filter(a => a.id_tab == item.id_tab & a.ID_Label == item.ID_Label).length })
            }
        })

        setFilterLabelList(filter_list);

    }, [stateList.listLabel]);

    useEffect(() => {

        var filter_list = [];

        //Преобразовываем пользователей в нужный формат
        stateList.listUser.map((item) => {
            if (filter_list.filter(a => a.id === item.ID_User & a.id_tab === item.id_tab).length == 0) {
                const name_ = stateUserList.list.filter(a => a.ID_User === item.ID_User).length > 0 ? stateUserList.list.filter(a => a.ID_User === item.ID_User)[0].Name_User : 'Не найден...'
                filter_list.push({ id: item.ID_User, id_tab: item.id_tab, name: name_, count: stateList.listUser.filter(a => a.id_tab == item.id_tab & a.ID_User == item.ID_User).length })
            }
        })

        setFilterUserList(filter_list);

    }, [stateList.listUser]);

    function loadFuture() {
        if (stateList.listLoaded.filter(a => a.id_tab === 3).length === 0) {
            axios.get('/api_tracker/task/listFuture')
                .then((res) => {
                    if (res.data.Status === 1) {
                        dispatch(loadList({ list: res.data.Data, id_tab: 3 }));
                        //Заполняем ИД задач                   
                        const id_tasks = res.data.Data.map((item) => {
                            return item.ID;
                        })

                        if (id_tasks.length > 0) {
                            loadDataForTask(id_tasks, 3)
                        }
                    }
                })
                .catch((err) => {
                    ErrorAdd(err, window.location.href);
                });
        }
    }
    /*************************START ВСЕ ЗАДАЧИ***********************************/
    function loadAllTasks() {

        setTab(tab_ => tab_.map(item => {
            if (item.id_tab === 4) {
                return { ...item, loading: true, loading1: true, loading2: true, loading3: true }
            }
            else {
                return item;
            }
        }))

        axios.get('/api_tracker/task/listActiveAll')
            .then((res) => {
                if (res.data.Status === 1) {
                    dispatch(loadList({ list: res.data.Data, id_tab: 4 }));
                    //Заполняем ИД задач                   
                    const id_tasks = res.data.Data.map((item) => {
                        return item.ID;
                    })

                    if (id_tasks.length > 0) {
                        loadDataForTask(id_tasks, 4);
                    }
                    else {
                        setTab(tab_ => tab_.map(item => {
                            if (item.id_tab === 4) {
                                return { ...item, loading: false, loading1: false, loading2: false, loading3: false }
                            }
                            else {
                                return item;
                            }
                        }))
                    }
                }
            })
            .catch((err) => {
                ErrorAdd(err, window.location.href);
            });
    }
    /**************************END ВСЕ ЗАДАЧИ************************************/
    /*********************START ЗАВЕРШЕННЫЕ ЗАДАЧИ*******************************/
    const [completedDateStart, setCompletedDateStart] = useState(null);
    const [completedDateEnd, setCompletedDateEnd] = useState(null);

    //Событие изменения даты
    function completedDateHandler(dateStart, dateEnd) {
        setCompletedDateStart(dateStart);
        setCompletedDateEnd(dateEnd);

        if (tabSelected === 5) {
            loadCompletedTasks(dateStart, dateEnd);
        }
    }
    //Загрузит список завершенных задач
    function loadCompletedTasks(dateStart, dateEnd) {
        setTab(tab_ => tab_.map(item => {
            if (item.id_tab === 5) {
                return { ...item, loading: true, loading1: true, loading2: true, loading3: true }
            }
            else {
                return item;
            }
        }))

        axios.get('/api_tracker/task/listCompleted', { params: { Date_Start: dateStart, Date_End: dateEnd } })
            .then((res) => {
                if (res.data.Status === 1) {
                    dispatch(loadList({ list: res.data.Data, id_tab: 5 }));
                    //Заполняем ИД задач                   
                    const id_tasks = res.data.Data.map((item) => {
                        return item.ID;
                    })

                    if (id_tasks.length > 0) {
                        loadDataForTask(id_tasks, 5)
                    }
                    else {
                        setTab(tab_ => tab_.map(item => {
                            if (item.id_tab === 5) {
                                return { ...item, loading: false, loading1: false, loading2: false, loading3: false }
                            }
                            else {
                                return item;
                            }
                        }))
                    }
                }
            })
            .catch((err) => {
                ErrorAdd(err, window.location.href);
            });
    }
    /*********************END ЗАВЕРШЕННЫЕ ЗАДАЧИ*******************************/
    /***********************START ФИЛЬТР МЕТОК*********************************/
    const [filterLabelSelected, setFilterLabelSelected] = useState([{ id_tab: 0, val: -1 }, { id_tab: 1, val: -1 }, { id_tab: 2, val: -1 }, { id_tab: 3, val: -1 }, { id_tab: 4, val: -1 }, { id_tab: 5, val: -1 }]);

    function filterLabelHandler(id_label, id_tab) {

        const val_ = filterLabelSelected.filter(a => a.id_tab === id_tab)[0].val === id_label ? -1 : id_label;

        const list = filterLabelSelected.map(item => {
            if (item.id_tab === id_tab) {
                return { ...item, val: val_ }
            }
            else {
                return { ...item }
            }
        })

        dispatch(filterLabel({ id_tab: id_tab, id_label: val_ }));
        setFilterLabelSelected(list);
    }
    /************************END ФИЛЬТР МЕТОК**********************************/
    /**********************START ФИЛЬТР ПРОЕКТОВ*******************************/
    const [filterProjectSelected, setFilterProjectSelected] = useState([{ id_tab: 0, val: -1 }, { id_tab: 1, val: -1 }, { id_tab: 2, val: -1 }, { id_tab: 3, val: -1 }, { id_tab: 4, val: -1 }, { id_tab: 5, val: -1 }]);

    function filterProjectHandler(id_project, id_tab) {

        const val_ = filterProjectSelected.filter(a => a.id_tab === id_tab)[0].val === id_project ? -1 : id_project;

        const list = filterProjectSelected.map(item => {
            if (item.id_tab === id_tab) {
                return { ...item, val: val_ }
            }
            else {
                return { ...item }
            }
        })

        dispatch(filterProject({ id_tab: id_tab, id_project: val_ }));
        setFilterProjectSelected(list);
    }
    /***********************END ФИЛЬТР ПРОЕКТОВ********************************/
    /********************START ФИЛЬТР ПОЛЬЗОВАТЕЛЕЙ****************************/
    const [filterUserSelected, setFilterUserSelected] = useState([{ id_tab: 0, val: -1 }, { id_tab: 1, val: -1 }, { id_tab: 2, val: -1 }, { id_tab: 3, val: -1 }, { id_tab: 4, val: -1 }, { id_tab: 5, val: -1 }]);

    function filterUserHandler(id_user, id_tab) {

        const val_ = filterUserSelected.filter(a => a.id_tab === id_tab)[0].val === id_user ? -1 : id_user;

        const list = filterUserSelected.map(item => {
            if (item.id_tab === id_tab) {
                return { ...item, val: val_ }
            }
            else {
                return { ...item }
            }

        })
        dispatch(filterUser({ id_tab: id_tab, id_user: val_ }));
        setFilterUserSelected(list);
    }
    /*********************END ФИЛЬТР ПОЛЬЗОВАТЕЛЕЙ*****************************/
    /**********************START ИЗМЕНЕНИЕ ЗАДАЧИ******************************/

    const [modalEditShow, setModalEditShow] = useState(false);
    const [model, setModel] = useState({});

    //Событие изменения задачи
    function editHandler(model) {
        setModel(model);
        //Заполняем виджет метки       
        setModalEditShow(true);

        //Сделает задачу просмотренной
        if (model.Viewed != true & (model.id_tab === 1 || model.id_tab === 2)) {
            axios.post('/api_tracker/task/userView', { ID_Task: model.ID })
                .then((res) => {
                    //dispatch(view({ id_task: model.ID }));
                })
                .catch((err) => {
                    ErrorAdd(err, window.location.href);
                });
        }
    }
    /***********************END ИЗМЕНЕНИЕ ЗАДАЧИ*******************************/
    /*************************START ДОБАВЛЕНИЕ*********************************/
    const [modalAddShow, setModalAddShow] = useState(false);
    const [loadingAdd, setLoadingAdd] = useState(false);
    const [logAdd, setLogAdd] = useState(null);


    function addHandler(name, idProject) {
        setLoadingAdd(true);
        setLogAdd(null);

        axios.post('/api_tracker/task/add', { ID_Project: idProject, ID_Type: 1, Priority: 0, Name: name })
            .then((res) => {
                if (res.data.Status === 1) {
                    getNew(res.data.Data);
                    //Открываем вкладку с черновиками
                    setTabSelected(0);
                }
                else {
                    setLogAdd(res.data.Error);
                    setLoadingAdd(false);
                }
            })
            .catch((err) => {
                setLogAdd('Неизвестная ошибка!');
                setLoadingAdd(false);
                ErrorAdd(err, window.location.href);
            });
    }

    //Откроет новый проект в модальном окне
    function getNew(id) {

        axios.get('/api_tracker/task/get', { params: { ID_Task: id } })
            .then((res) => {
                if (res.data.Status == 1) {
                    setModel(res.data.Data);
                    setModalAddShow(false);
                    setModalEditShow(true);
                    setLoadingAdd(false);
                }
                else {
                    setLoadingAdd(false);
                    setLogAdd(res.Error);
                }
            })
            .catch((err) => {
                setLogAdd('Неизвестная ошибка!');
                setLoadingAdd(false);
                ErrorAdd(err, window.location.href);
            });
    }

    /**************************END ДОБАВЛЕНИЕ**********************************/

    function tabHandler(id_tab) {
        setTabSelected(id_tab)

        if (id_tab === 3) {
            loadFuture();
        }
        if (id_tab === 4) {
            loadAllTasks();
        }
        if (id_tab === 5) {
            loadCompletedTasks(completedDateStart, completedDateEnd);
        }
    }


    return (
        <div className='admin_content'>
            {modalAddShow === true && (
                <TaskModalAdd show={modalAddShow} idObject={id_object} onHide={() => setModalAddShow(false)} title='Добавление задачи' error={logAdd} loading={loadingAdd} updateHandler={addHandler} showProject={true} />
            )}
            {modalEditShow === true && (
                <ModalUpdate show={modalEditShow} onHide={() => setModalEditShow(false)} edit={true} /*model={model}*/ idTask={model.ID} />
            )}
            <div className="">
                {stateSetting.companyService != null && (
                    stateSetting.companyService.ID_Role === 2 ? (
                        <TabBar tabData={tab.filter(a => a.hideUser === false)} tabSelected={tabSelected} tabClikHandler={tabHandler} filterShow={filterShow} setFilterShow={setFilterShow} showAdd={true} setAddShow={setModalAddShow} showFilter={true} />

                    ) : (
                        <TabBar tabData={tab} tabSelected={tabSelected} tabClikHandler={tabHandler} filterShow={filterShow} setFilterShow={setFilterShow} showAdd={true} setAddShow={setModalAddShow} showFilter={true} />
                    )
                )}
            </div>
            {tab.map(tab => (
                <div key={tab.id_tab} className={tab.id_tab !== tabSelected ? "d-none" : ""}>
                    <div className={filterShow === false ? "d-none" : ""}>
                        <div className="filter-container mt-10">
                            <div className="filter-title"><FontAwesomeIcon icon={faFilter} />ФИЛЬТР</div>
                            {tab.id_tab === 5 && (
                                <FilterDate defaultVal={4} changHandler={completedDateHandler} />
                            )}
                            <FilterUniversal filterName="Проекты" filterIcon={faDiagramProject} list={stateList.filterProject.filter(a => a.id_tab === tab.id_tab)} id_filter={tab.id_tab} clickHandler={filterProjectHandler} selected={filterProjectSelected.filter(a => a.id_tab === tab.id_tab)[0].val} show_count={true} />
                            {tab.id_tab === 4 && (
                                <FilterUniversal filterName="Ответственные" filterIcon={faUser} list={filterUserList.filter(a => a.id_tab === tab.id_tab)} show_count={true} id_filter={tab.id_tab} clickHandler={filterUserHandler} selected={filterUserSelected.filter(a => a.id_tab === tab.id_tab)[0].val} />
                            )}
                            <FilterUniversal filterName="Метки" filterIcon={faTag} list={filterLabelList.filter(a => a.id_tab === tab.id_tab)} show_count={true} id_filter={tab.id_tab} clickHandler={filterLabelHandler} selected={filterLabelSelected.filter(a => a.id_tab === tab.id_tab)[0].val} />
                        </div>
                    </div>
                    {tab.loading === true ? (<div className="loader_01 mt-30"></div>)
                        : (
                            stateList.list.filter(a => a.id_tab === tab.id_tab & a.filter_label === 0 & a.filter_project === 0 & a.filter_user === 0).length === 0 ? (
                                <InfoNoData text="Нет задач" />
                            ) : (
                                <DisplayTable key={0}
                                    editHandler={editHandler}
                                    list={stateList.list.filter(a => a.id_tab === tab.id_tab & a.filter_label === 0 & a.filter_project === 0 & a.filter_user === 0)}
                                    listLabel={stateList.listLabel.filter(a => a.id_tab === tab.id_tab)}
                                    listCheckList={stateList.listCheckList.filter(a => a.id_tab === tab.id_tab)}
                                    idTab={tab.id_tab}
                                />
                            )
                        )}
                </div>
            ))}
        </div>
    );
}

export default Index;
